/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable arrow-body-style */
/*  eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { ofType, createEffect, Actions } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';

import { WindowService } from '@cigna/shared/angular/core/window-util';
import {
  map,
  catchError,
  switchMap,
  tap,
  filter,
  withLatestFrom,
} from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import * as fromAppstate from './appstate.reducer';
import * as fromAppstateActions from './appstate.actions';
import { TranslateService } from '@ngx-translate/core';
import {
  AlertResponse,
  GetNavigationsResponse,
  ToolsResponse,
  UserAgreementResponse,
  Role,
} from './appstate.models';

import {
  checkError,
  RouteData,
  ServiceError,
} from '@cigna/cigna-for-brokers/shared/util';

import { RouterFacade } from '@cigna/shared/angular/core/router-state-data-access';
import { AppstateService } from './appstate.service';
import { Store } from '@ngrx/store';
import { AppstateFacade } from './appstate.facade';
import { CFBAnalyticsService } from '@cigna/cigna-for-brokers/shared/analytics-util';
import {
  DataLayerError,
  DataLayerPageAction,
  DataLayerPageLoad,
} from '@cigna/shared/angular/analytics-data-access';
import { CookieService } from 'ngx-cookie-service';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import {
  ProfileType,
  getAgencyList,
  getAgencyListSuccess,
  getAgencyListFailure,
  AgencyListRes,
  AppService,
  postAffirm,
  PostAffirmSuccessRes,
  postAffirmSuccess,
  postAffirmFailure,
} from '@cigna/cigna-for-brokers/shared/data-access';

const TOKEN_COOKIE = 'accessToken';

@Injectable()
export class AppstateEffects {
  getAlerts$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fromAppstateActions.getAlerts),
      withLatestFrom(this._store$),
      fetch<
        [fromAppstate.AppState],
        ReturnType<typeof fromAppstateActions.getAlerts>
      >({
        run: (_action: ReturnType<typeof fromAppstateActions.getAlerts>) =>
          this._service.getAlerts().pipe(
            tap((payload: AlertResponse) => {
              this._service.hideLoader();
              if (
                payload.metadata &&
                payload.metadata.outcome &&
                payload.metadata.outcome.additionalDetails &&
                payload.metadata.outcome.additionalDetails.length &&
                payload.metadata.outcome.status &&
                payload.metadata.outcome.status.toString() !== '200'
              ) {
                const error: ServiceError = checkError(payload);
              }
            }),
            map((payload: AlertResponse) =>
              fromAppstateActions.getAlertsSuccess({
                payload,
              }),
            ),
          ),
        onError: (_, error) =>
          of(fromAppstateActions.getAlertsFailure({ error })),
      }),
    ),
  );
  dismissAlert$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fromAppstateActions.dismissAlert),
      switchMap(({ dismissAlertRequest }) =>
        this._service.dismissAlert(dismissAlertRequest).pipe(
          tap((payload: AlertResponse) => {
            if (
              payload.metadata &&
              payload.metadata.outcome &&
              payload.metadata.outcome.status !== 200
            ) {
              const error: ServiceError = checkError(payload);
            }
          }),
          map((payload: AlertResponse) =>
            fromAppstateActions.dismissAlertSuccess({
              payload,
              alertMsgId: dismissAlertRequest.alertMsgId,
            }),
          ),
          catchError((error) =>
            of(fromAppstateActions.dismissAlertFailure({ error })),
          ),
        ),
      ),
    ),
  );

  getUserAgreement$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fromAppstateActions.getUserAgreement),
      withLatestFrom(this._store$),
      fetch<
        [fromAppstate.AppState],
        ReturnType<typeof fromAppstateActions.getUserAgreement>
      >({
        run: (
          _action: ReturnType<typeof fromAppstateActions.getUserAgreement>,
        ) =>
          this._service.getUserAgreement().pipe(
            tap((_payload: UserAgreementResponse) => {
              this._service.hideLoader();
            }),
            map((payload: UserAgreementResponse) =>
              fromAppstateActions.getUserAgreementSuccess({
                payload,
              }),
            ),
          ),
        onError: (_, error) =>
          of(fromAppstateActions.getUserAgreementFailure({ error })),
      }),
    ),
  );

  getBrokerNavigation$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fromAppstateActions.getBrokerNavigations),
      withLatestFrom(this._store$),
      fetch<
        [fromAppstate.AppState],
        ReturnType<typeof fromAppstateActions.getBrokerNavigations>
      >({
        run: (
          _action: ReturnType<typeof fromAppstateActions.getBrokerNavigations>,
        ) =>
          this._service.getBrokerNavigations().pipe(
            map((payload: GetNavigationsResponse) =>
              fromAppstateActions.getBrokerNavigationsSuccess({
                payload,
              }),
            ),
          ),
        onError: (_, error) =>
          of(fromAppstateActions.getBrokerNavigationsFailure({ error })),
      }),
    ),
  );

  getTools$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fromAppstateActions.getTools),
      withLatestFrom(this._store$),
      fetch<
        [fromAppstate.AppState],
        ReturnType<typeof fromAppstateActions.getTools>
      >({
        run: (_action: ReturnType<typeof fromAppstateActions.getTools>) =>
          this._service.getTools().pipe(
            map((payload: ToolsResponse) =>
              fromAppstateActions.getToolsSuccess({
                payload,
              }),
            ),
            catchError((error) =>
              of(fromAppstateActions.getToolsFailure({ error })).pipe(
                tap(() => {
                  const errorCd = error.error?.metadata?.outcome
                    ?.additionalDetails
                    ? error.error?.metadata?.outcome?.additionalDetails[0].code
                    : '67778';
                  this._store$.dispatch(
                    fromAppstateActions.sendAnalytics({
                      data: {
                        event: 'error',
                        reqData: {
                          requirementId: 'acCFBGlobER001',
                          userStory: 'MTD-3109',
                          hitType: 'error',
                        },
                        errorData: {
                          errorType: 'Tools_Tile',
                          errorCause:
                            'We had trouble loading this information. Please try again later or Contact Us.',
                          errorCode: errorCd,
                        },
                      },
                    }),
                  );
                }),
              ),
            ),
          ),
        onError: (_, error) =>
          of(fromAppstateActions.getToolsFailure({ error })),
      }),
    ),
  );

  processLogout$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(fromAppstateActions.logout),
        withLatestFrom(
          this.featureTogglesFacade.featuresEnabled(['isOktaLoginEnabled']),
        ),
        switchMap(([{ variation, linkName }, isOktaEnabled]) =>
          this._service.logOut().pipe(
            tap(() => {
              this.logoutRedirectSetup(isOktaEnabled);
            }),
            catchError((_error) => {
              this.logoutRedirectSetup(isOktaEnabled);
              return _error;
            }),
          ),
        ),
      ),
    { dispatch: false },
  );

  impersonatorLogoutPost$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fromAppstateActions.impersonatorLogoutPost),
      switchMap((action) =>
        this._service.impersonatorLogoutPost().pipe(
          map((res) => {
            if (
              res &&
              res.status.toString() === '200' &&
              res.statusText.toUpperCase() === 'OK'
            ) {
              return fromAppstateActions.impersonatorLogoutSuccess({
                isSignin: action.isSignin,
              });
            }
            return fromAppstateActions.impersonatorLogoutGet({
              isSignin: action.isSignin,
            });
          }),
          catchError(() =>
            of(
              fromAppstateActions.impersonatorLogoutGet({
                isSignin: action.isSignin,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  impersonatorLogoutGet$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fromAppstateActions.impersonatorLogoutGet),
      switchMap((action) =>
        this._service.impersonatorLogoutGet().pipe(
          map(() =>
            fromAppstateActions.impersonatorLogoutSuccess({
              isSignin: action.isSignin,
            }),
          ),
          catchError(() =>
            of(
              fromAppstateActions.impersonatorLogoutSuccess({
                isSignin: action.isSignin,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  impersonatorLogoutGetSuccess = createEffect(
    () =>
      this._actions$.pipe(
        ofType(fromAppstateActions.impersonatorLogoutSuccess),
        tap((action) => this.impersonatorLoginRedirect(action.isSignin)),
      ),
    { dispatch: false },
  );

  processStaySignIn$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(fromAppstateActions.staySignIn),
        switchMap((action) =>
          this._service.staySignIn().pipe(
            tap(() => {
              this.dialogRef.closeAll();
            }),
            catchError((_error) => {
              this.dialogRef.closeAll();
              return _error;
            }),
          ),
        ),
      ),
    { dispatch: false },
  );

  windowOpen$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(fromAppstateActions.windowOpen),
        tap((data) => {
          this._window.open(data.url, data.target);
        }),
      ),
    { dispatch: false },
  );
  routeChange$ = createEffect(
    () =>
      this.router.events.pipe(
        filter((e) => e instanceof NavigationEnd),
        withLatestFrom(
          this.routerFacade.data$ as Observable<RouteData>,
          this.routerFacade.url$,
        ),
        map(([, data, url]) => {
          // this.analytics.trackPageLoad(data, url);
        }),
      ),
    { dispatch: false },
  );

  getAgencyList$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getAgencyList),
      /* eslint-disable sonarjs/cognitive-complexity, no-empty-pattern */

      switchMap(() =>
        this._appService.getAgencyList().pipe(
          // eslint-disable-next-line sonarjs/no-identical-functions
          tap((payload: AgencyListRes) => {
            if (payload.metadata && payload.metadata.outcome) {
              const error: ServiceError = checkError(payload);
            }
          }),
          switchMap((payload: AgencyListRes) => {
            const actions = [];
            if (
              payload.metadata &&
              payload.metadata.outcome &&
              payload.metadata.outcome.status === 200
            ) {
              actions.push(
                getAgencyListSuccess({
                  payload,
                }),
              );
              return actions;
            }
            const error: ServiceError = checkError(payload);
            return [getAgencyListFailure({ error })];
          }),
          catchError((error) =>
            of(
              getAgencyListFailure({
                error: error.error.metadata ? checkError(error.error) : error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  getAgencyListFailure$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(getAgencyListFailure),
        tap(({ error }) => {}),
      ),
    { dispatch: false },
  );

  postAffirm$ = createEffect(() =>
    this._actions$.pipe(
      ofType(postAffirm),
      // /* eslint-disable sonarjs/cognitive-complexity, no-empty-pattern */
      switchMap(({ request }) =>
        this._appService.postAffirm(request).pipe(
          // eslint-disable-next-line sonarjs/no-identical-functions
          tap((payload: PostAffirmSuccessRes) => {
            if (payload.metadata && payload.metadata.outcome) {
              const error: ServiceError = checkError(payload);
              // this.analytics.trackServiceError(
              //   {},
              //   'POST: Post Affirm',
              //   error,
              //   'Error on While making postAffirm:POST',
              // );
            }
          }),
          switchMap((payload: PostAffirmSuccessRes) => {
            const actions = [];
            if (
              payload.metadata &&
              payload.metadata.outcome &&
              payload.metadata.outcome.status === 200
            ) {
              actions.push(
                postAffirmSuccess({
                  request,
                  payload,
                }),
              );
              return actions;
            }
            const error: ServiceError = checkError(payload);
            return [postAffirmFailure({ error })];
          }),

          catchError((error) => {
            const errorCd = error.error?.metadata?.outcome
              ? error.error?.metadata?.outcome.code
              : '123480';
            this._store$.dispatch(
              fromAppstateActions.sendAnalytics({
                data: {
                  event: 'error',
                  reqData: {
                    requirementId: 'acCFBGlobER001',
                    userStory: 'MTD-3480',
                    hitType: 'error',
                  },
                  errorData: {
                    errorType: 'Compensation_Legal_Accept',
                    errorCause:
                      'Oops. Something went wrong. Please try again later or Contact Us.',
                    errorCode: errorCd,
                  },
                },
              }),
            );

            return of(
              postAffirmFailure({
                error: error.error.metadata
                  ? checkError(error.error)
                  : { message: error.message, status: 500, errObject: error },
              }),
            );
          }),
        ),
      ),
    ),
  );

  postAffirmFailure$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(postAffirmFailure),
        tap(({ error }) => {}),
      ),
    { dispatch: false },
  );

  logoutRedirectSetup(isOktaEnabled: boolean) {
    this._service.hideLoader();
    this.dialogRef.closeAll();
    sessionStorage.removeItem('spcode');
    localStorage.removeItem('isLastLoginUpdated');
    localStorage.removeItem('activeNavMenu');
    if (!isOktaEnabled) {
      let urlLogout = '/web/logout';
      if (location.hostname === 'localhost') {
        urlLogout = 'https://int2.cignaforbrokers.com/web/login';
      }
      window.location.href = urlLogout;
    }
  }

  impersonatorLoginRedirect(isSignin: boolean) {
    this.dialogRef.closeAll();
    this.clearSessionTokenCookie();
    const redirectURL = isSignin
      ? '/impersonator/switchuser'
      : '/impersonator/login';
    this.router.navigate([redirectURL]);
  }

  clearSessionTokenCookie() {
    const domain = window.location.hostname;
    this._cookie.delete(TOKEN_COOKIE, '/', domain);
  }

  updateAnalytics$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(fromAppstateActions.sendAnalytics),
        withLatestFrom(
          this._appstateFacade.ssoIdEnc$,
          this._appstateFacade.roles$,
          this._appstateFacade.lobBeforeLogin$,
          this._appstateFacade.isProfileUser$,
          this._appstateFacade.partyRole$,
          this._appstateFacade.agencyName$,
        ),
        tap(
          ([
            actionPayload,
            ssoIdEnc,
            roles,
            lobBeforeLogin,
            profileData,
            ptyRole,
            agncyName,
          ]) => {
            this.sendAnalyticsData(
              actionPayload.data,
              ssoIdEnc,
              roles,
              lobBeforeLogin,
              profileData,
              ptyRole,
              agncyName,
            );
          },
        ),
      ),
    { dispatch: false },
  );

  sendAnalyticsData(
    actionPayloadData: DataLayerPageAction | DataLayerPageLoad | DataLayerError,
    ssoIdEnc: string | undefined,
    roles: Role[] | undefined,
    lobBeforeLogin: string | undefined,
    profileData: ProfileType | null,
    ptyRole: string | undefined,
    agncyName: string | undefined,
  ) {
    const lobs: string[] = [];
    roles?.forEach((roleitem) => {
      lobs.push(roleitem.lob);
    });
    const peid = profileData
      ? profileData.accessTokenBody['cigna.userPeId']
      : '';
    const noEmpty = lobs.sort().filter((v) => v.trim() !== '');
    const uniqeLobs = [...new Set(noEmpty)];
    const agyNm = agncyName?.substring(0, 250);
    const userData = {
      SSOID: ssoIdEnc,
      LOB:
        uniqeLobs.length > 1
          ? uniqeLobs.join('^')
          : uniqeLobs[0]
          ? uniqeLobs[0]
          : lobBeforeLogin,
      loginStatus: ssoIdEnc ? 'logged in' : 'not logged in',
      PEID: peid,
      agencyName: agyNm,
      partyRole: ptyRole,
    };

    switch (actionPayloadData.event) {
      case 'pageAction': {
        this.cfbAnalytics.dataLayer.trackPageAction({
          ...actionPayloadData,
          userData,
        });
        break;
      }
      case 'pageLoad': {
        this.cfbAnalytics.dataLayer.trackPageLoad({
          ...actionPayloadData,
          userData,
        });
        break;
      }
      case 'error': {
        this.cfbAnalytics.dataLayer.trackError({
          ...actionPayloadData,
        });
        break;
      }
    }
  }

  constructor(
    private _service: AppstateService,
    private _appService: AppService,
    private _actions$: Actions,
    private dialogRef: MatDialog,
    private router: Router,
    _translateService: TranslateService,
    private _window: WindowService,
    private routerFacade: RouterFacade,
    private _store$: Store<fromAppstate.AppState>,
    public _appstateFacade: AppstateFacade,
    private cfbAnalytics: CFBAnalyticsService,
    private _cookie: CookieService,
    private featureTogglesFacade: FeatureTogglesFacade,
  ) {}
}
